export const SOCKET_CONNECTION_IN_PROGRESS = 'SOCKET_CONNECTION_IN_PROGRESS';
export const SOCKET_CONNECTION_SUCCESS = 'SOCKET_CONNECTION_SUCCESS';
export const SOCKET_CONNECTION_ERROR = 'SOCKET_CONNECTION_ERROR';
export const SOCKET_RECONNECTION_ERROR = 'SOCKET_RECONNECTION_ERROR';
export const SOCKET_CONNECTION_CLOSE = 'SOCKET_CONNECTION_CLOSE';
export const RECONNECT_MAX_TIME = 60000;
export const RECONNECT_INTERVAL_TIME = 10000;
export const TIMER_SET = 'TIMER_SET';
